<template>
  <!-- Example usage:
    <autocompleteMultiLuRole
      v-model="selectedUser.UserRole" (the collection we are updating)
      selfKey="UserID" (how the selectedUser is referenced in the join item)
      :selfID="selectedUser.ID" (to create new entries we need the selected users ID)
      relatedItemKey="RoleID" (this is how the lookup is referenced in the join)
      joinItemName="UserRole" (this is the name of the join (for the js class))
    ></autocompleteMultiLuRole>
  -->
  <v-autocomplete
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :search-input.sync="searchInput"
    @change="searchInput = ''"
    :rules="rules"
    :loading="loading"
    chips
    deletable-chips
    multiple
    dense
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import Comment from '@classes/Comment'
import Document from '@classes/Document'
import Link from '@classes/Link'
import Notification from '@classes/Notification'
import TrackedBillAssignment from '@classes/TrackedBillAssignment'
import TrackedBill from '@classes/TrackedBill'
import TrackedBillUser from '@classes/TrackedBillUser'
import UserAgency from '@classes/UserAgency'
import UserRole from '@classes/UserRole'
export default {
  name: 'autocomplete-multi-join-users',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Users',
    },
    value: Array,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    items: Array,
    joinItemName: {
      type: String,
      required: true,
      //default: 'Comment',
      //default: 'Document',
      //default: 'Link',
      //default: 'Notification',
      //default: 'TrackedBillAssignment',
      //default: 'TrackedBill',
      //default: 'TrackedBill',
      //default: 'TrackedBillUser',
      //default: 'UserAgency',
      //default: 'UserRole',
    },
    relatedItemKey: {
      type: String,
      required: true,
      //default: 'UserID',
    },
    selfKey: {
      type: String,
      required: true,
    },
    selfID: {
      type: Number,
      required: true,
    },
    billID: {
      type: Number,
    },
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'FirstName',
      itemText: 'LastName',
      itemText: 'Email',
      searchInput: '',
    }
  },
  watch: {
    value(nval, oval) {
      if (nval != oval) {
        this.searchInput = ''
      }
    },
  },
  computed: {
    ...get('user', ['users', 'loading']),
    availableItems() {
      var list = []
      var fullList = []
      if (this.items) {
        fullList = this.items
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.items.filter((i) => true)
      } else {
        fullList = this.users
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.users.filter((i) => true)
      }
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = fullList.find((i) => i.ID == this.value)
        if (!list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        let textField = this.itemText
        let sort = a[textField] > b[textField] ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value && this.value.length > 0) {
          return [
            ...new Set(this.value.map((item) => item[this.relatedItemKey])),
          ]
        } else {
          return []
        }
      },
      set(newValue) {
        if (this.value) {
          this.value.forEach((relation, index, object) => {
            if (!newValue.includes(relation[this.relatedItemKey])) {
              //need to remove item
              object.splice(index, 1)
            }
          })
          newValue.forEach((itemID) => {
            if (!this.value.find((i) => i[this.relatedItemKey] == itemID)) {
              // need to add item
              let item
              if (this.joinItemName == 'Comment') {
                item = new Comment()
              } else if (this.joinItemName == 'Document') {
                item = new Document()
              } else if (this.joinItemName == 'Link') {
                item = new Link()
              } else if (this.joinItemName == 'Notification') {
                item = new Notification()
                item.TrackedBillID = this.billID
              } else if (this.joinItemName == 'TrackedBillAssignment') {
                item = new TrackedBillAssignment()
              } else if (this.joinItemName == 'TrackedBill') {
                item = new TrackedBill()
              } else if (this.joinItemName == 'TrackedBill') {
                item = new TrackedBill()
              } else if (this.joinItemName == 'TrackedBillUser') {
                item = new TrackedBillUser()
              } else if (this.joinItemName == 'UserAgency') {
                item = new UserAgency()
              } else if (this.joinItemName == 'UserRole') {
                item = new UserRole()
              } else {
                item = {}
              }
              item[this.relatedItemKey] = itemID
              item[this.selfKey] = this.selfID
              this.value.push(item)
            }
          })
        }
      },
    },
  },
  created() {
    if (!this.items) {
      this.loadUsers()
    }
  },
  methods: {
    loadUsers: call('user/loadUsers'),
  },
}
</script>
<style>
</style>